module.exports = __webpack_public_path__ + "static/img/Group4.083b4641.png";